import React from "react";
import { EndProductInventory } from "./EndProductsTab";

export default function RefaqHome({ user }) {
  return <section dir="ltr">
    <h2 style={{ color: "var(--accent, #514536)" }}>Refaq Marble Furniture and Accessories</h2>
    {user.showroom_id ? <EndProductInventory showroomId={user.showroom_id} companyCode="refaq" /> : null}
  </section>;
}

export function RefaqStock() {
  return <EndProductInventory companyCode="refaq" />;
}
